<template>
    <v-layout justify-center align-center fill-height>
        <v-flex shrink align-center class="text-center">
            <h1 class="display-3">
                404 Not Found
            </h1>
            <h3>Oops, this isn't the page you're looking for</h3>
            Go <a href="/">home</a> or try a <a href="/s">search</a>
        </v-flex>
    </v-layout>
</template>
<script>
export default {}
</script>